// Ported from dev-scrips-pm-react services/scheduling/use-reminder-profiles-list.ts (PROD-1190 calendar port)
import { useQuery } from '@tanstack/react-query';
import { get } from '@/shared/api/api-client';
import type { ReminderProfile } from './use-prebook-appointment-profile';

/**
 * GET /api/Practice/ReminderList/{practiceId}
 *
 * Mirrors Flutter `getReminderProfile()` →
 * `settings_data_source_impl.dart:261-277`. Returns the practice's
 * configured reminder profiles for the manual-override picker.
 *
 * (PreBookSelectedAppointmentProfile.reminderList already supplies the
 * default — `appointment-profile-section.tsx` writes the first
 * `enableInAppBooking` entry on profile pick. This list is the broader
 * set the user can pick from when they want to override.)
 */
export function useReminderProfilesList(practiceId: string | null) {
  return useQuery({
    queryKey: ['reminder-profiles-list', practiceId],
    enabled: !!practiceId,
    queryFn: ({ signal }) =>
      get<ReminderProfile[]>(`/api/Practice/ReminderList/${practiceId}`, { signal }),
  });
}
